var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './Tooltip.css';
import cx from 'classnames';
import Portal from '../Portal/Portal';
var node = null;
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setTooltipRef = function (element) {
            if (element && _this.props.manualStyleValue) {
                _this.adjustTooltipPosition(element);
            }
        };
        _this.adjustTooltipPosition = function (tooltipEl) {
            var _a = _this.props, anchor = _a.anchor, position = _a.position, manualStyleValue = _a.manualStyleValue;
            if (!tooltipEl || !manualStyleValue)
                return;
            var tooltipRect = tooltipEl.getBoundingClientRect();
            var tooltipWidth = tooltipRect.width;
            var anchorPosition = anchor.getBoundingClientRect();
            var scrollX = typeof window.scrollX !== 'undefined' ? window.scrollX : window.pageXOffset;
            var anchorLeft = scrollX + anchorPosition.left;
            var anchorCenterX = anchorLeft + Math.round(anchorPosition.width / 2);
            var transform = manualStyleValue.transform;
            var arrowPosition = '';
            tooltipEl.style.removeProperty('--arrow-left');
            tooltipEl.style.removeProperty('--arrow-right');
            var isTop = position === 'top-center' || position === 'top';
            var isBottom = position === 'bottom-center' || position === 'bottom';
            var isLeftHalf = anchorCenterX < window.innerWidth - anchorCenterX;
            if (isTop || isBottom) {
                var translateY = isTop ? '-100%' : '0';
                if (isLeftHalf) {
                    var minOffset = Math.min(tooltipWidth * 0.5, anchorCenterX);
                    transform = "translate(-" + minOffset + "px, " + translateY + ")";
                    arrowPosition = minOffset + "px";
                    tooltipEl.style.setProperty('--arrow-left', arrowPosition);
                    tooltipEl.style.setProperty('--arrow-position-factor', '-1');
                }
                else {
                    var rightDistance = window.innerWidth - anchorCenterX;
                    var minOffset = Math.min(tooltipWidth * 0.5, rightDistance);
                    transform = "translate(" + minOffset + "px, " + translateY + ")";
                    arrowPosition = minOffset + "px";
                    tooltipEl.style.setProperty('--arrow-right', arrowPosition);
                    tooltipEl.style.setProperty('--arrow-position-factor', '2');
                }
            }
            tooltipEl.style.transform = transform;
        };
        return _this;
    }
    Tooltip.prototype.hide = function () {
        this.props.onDismiss && this.props.onDismiss();
    };
    Tooltip.prototype.renderChildren = function (props) {
        var _a;
        var currentProps = props || this.props;
        var className = currentProps.className, animate = currentProps.animate, dismissible = currentProps.dismissible, theme = currentProps.theme, manualStyleValue = currentProps.manualStyleValue, containerClassName = currentProps.containerClassName, activeClassName = currentProps.activeClassName, position = currentProps.position;
        var cardStyle = cx(styles['tooltip'], styles[position], (_a = {},
            _a[styles['active']] = true,
            _a[activeClassName || ''] = true,
            _a[styles['animate-move']] = animate,
            _a[styles['dismissible']] = dismissible,
            _a[styles['light']] = theme === 'light',
            _a), className);
        return (<div ref={this.setTooltipRef} className={cardStyle} style={manualStyleValue}>
				<div className={cx(styles['container'], containerClassName)}>
					{currentProps.children}
				</div>
			</div>);
    };
    Tooltip.prototype.render = function () {
        return null;
    };
    return Tooltip;
}(Portal({ node: node, nodeClassName: styles['tooltip-portal'] })));
export default Tooltip;
